import { createApi } from '@reduxjs/toolkit/query/react';

import { ApiResponse } from '../../../model';
import { API_CONSTANTS } from '../../../utils/constants';

import type { AddPermissionPayload, PermissionListResponse } from './model';
import { baseQueryWithReauth } from '../../../apis/baseQuery';

export const permissionApi = createApi({
  reducerPath: 'permissionApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['permissionData'],
  endpoints: (build) => ({
    permissionList: build.query<ApiResponse<PermissionListResponse>, void>({
      query: () => ({
        url: API_CONSTANTS.PERMISSIONS.PERMISSIONS_LIST_URL,
        method: 'GET',
      }),
      providesTags: ['permissionData'],
    }),
    permissionGroup: build.query<ApiResponse<PermissionListResponse>, void>({
      query: () => ({
        url: API_CONSTANTS.PERMISSIONS.PERMISSIONS_GROUP_URL,
        method: 'GET',
      }),
      providesTags: ['permissionData'],
    }),
    addNewPermission: build.mutation<ApiResponse<any>, AddPermissionPayload>({
      query: (body) => ({
        url: API_CONSTANTS.PERMISSIONS.ADD_PERMISSION_URL,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['permissionData'],
    }),
  }),
});

export const {
  useLazyPermissionListQuery,
  useLazyPermissionGroupQuery,
  useAddNewPermissionMutation,
} = permissionApi;
